import api from './index';
import { axios } from '@/utils/request';

export function getNewsList(data) {
    return axios({
        url: api.NEWS_LIST,
        method: 'POST',
        data
    })
}

export function getNewsDetail(data) {
    return axios({
        url: api.NEWS_DETAIL,
        method: 'POST',
        data
    })
}